import React, { useEffect, useRef } from 'react';
import Spinner from '../../Spinner/Spinner';
import { theme } from '../../../../core/theme/theme';
import './styles/custom.button.styles.css';

interface CustomButtonProps {
    id?: string;
    title?: string;
    text: string;
    onClick: any;
    textColor?: string;
    spinnerColor?: string;
    color?: string;
    fontSize?: number | string;
    fontFamily?: string;
    padding?: number | string;
    width?: number | string;
    isLoading?: boolean;
    marginTop?: number | string;
    isDisabled?: boolean;
}
const CustomButton: React.FC<CustomButtonProps> = ({
    id,
    title,
    text,
    onClick,
    textColor,
    spinnerColor,
    color,
    fontSize,
    fontFamily,
    padding,
    width,
    isLoading,
    marginTop,
    isDisabled,
}) => {
    const buttonRef = useRef(null);

    useEffect(() => {
        //@ts-ignore
        buttonRef.current.addEventListener('mousedown', (e) => e.stopPropagation());
    }, []);
    return (
        <button
            title={title ? title : undefined}
            ref={buttonRef}
            id={id}
            className="custom-button"
            onClick={onClick}
            disabled={isDisabled}
            style={{
                padding: padding ? padding : 5,
                marginTop: marginTop && marginTop,
                backgroundColor: color ? `${color}` : theme.colors.default,
                width: width && width,
                fontSize: fontSize,
                fontFamily: fontFamily ? fontFamily : theme.fonts.custom,
                color: textColor ? `${textColor}` : isDisabled ? 'grey' : 'black',
                cursor: 'pointer',
            }}
        >
            {isLoading ? (
                <Spinner isLoading={isLoading} size={10} margin="auto" color={spinnerColor ? spinnerColor : 'white'} />
            ) : (
                text
            )}
        </button>
    );
};

export default CustomButton;
